import React, { useState } from "react";
import AsteroidGame from "./Asteroid/Game";
import ViewPage from "./ViewPage";

export default function AsteroidPage() {
  const [asteroidSpeed, setAsteroidSpeed] = useState(20);
  const [playerSpeed, setPlayerSpeed] = useState(20);
  const [playerWidth, setPlayerWidth] = useState(70);
  const [population, setPopulation] = useState(100);

  const data = [
    {
      value: asteroidSpeed,
      setter: setAsteroidSpeed,
      name: "Asteroid Speed",
      min: 5,
      max: 40,
    },
    {
      value: playerSpeed,
      setter: setPlayerSpeed,
      name: "Player Speed",
      min: 5,
      max: 40,
    },
    {
      value: playerWidth,
      setter: setPlayerWidth,
      name: "Player Width",
      min: 5,
      max: 100,
    },
    {
      value: population,
      setter: setPopulation,
      name: "Population",
      min: 10,
      max: 1000,
    },
  ];

  return (
    <div className="App">
      <ViewPage
        Game={AsteroidGame}
        options={{
          agentsNum: population,
          asteroidSpeed,
          playerSpeed,
          playerWidth,
        }}
        data={data}
      />
    </div>
  );
}
